module.exports = __webpack_public_path__ + "img/ep_sys_wx_tip.27f1bda1.jpg";